<template>
    <div class="absolute inset-0">
        <div
            v-for="bg in backgrounds"
            :key="bg.z"
            class="absolute inset-0 bg-contain bg-no-repeat transition-opacity duration-200 ease-in-out"
            :style="{
                backgroundImage: `url(${bg.url})`,

                opacity: bg.opacity,
                zIndex: bg.z
            }"
        ></div>
    </div>
</template>

<script>
    export default {
        props: {
            background: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                backgrounds: [],

                nextZ: 1,
            };
        },

        watch: {
            background: {
                immediate: true,
                handler(newBackground) {
                    this.changeBackground(newBackground);
                },
            },
        },

        methods: {
            changeBackground(url) {
                this.nextZ += 1;

                const layer = {
                    url,
                    opacity: 0,
                    z: this.nextZ,
                };

                this.backgrounds.push(layer);

                // Preload.
                const img = new Image();

                img.onload = () => {
                    setTimeout(() => {
                        layer.opacity = 1;

                        this.backgrounds = [...this.backgrounds];

                        setTimeout(() => {
                            this.backgrounds = this.backgrounds.filter((bg) => bg.z >= layer.z);
                        }, 250);
                    }, 100);
                };

                img.src = url;
            },
        },
    };
</script>
